import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function OtherList({ theme = '', data = {} }: any) {
    const { Link, useLang, isMobile } = useGlobal();
    const { t } = useLang('shared');
    const msg1 = t('product.site_details_product_others');
    const msg2 = t('product.site_details_product_view_more');
    const msg3 = t('support.site_support_learn_more');
    const items = data?.items || [];

    return (
        <div className={`${css.otherlist} ${isMobile ? 'otherlist-h5' : 'otherlist-pc'} ${theme} otherlist`}>
            <div className="list-h">
                <div className="list-h-l">{msg1}</div>
                <Link
                    className="list-h-r"
                    href={data.moreUrl}
                    ariaLabel={msg1}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'view_more',
                        list_name: 'You might also like',
                        button_name: 'view_more',
                    }}
                >
                    {msg2}
                    <EFArrowDown className="list-h-icon" />
                </Link>
            </div>
            <ul className="list-c">
                {items.map((item: any) => (
                    <li className="list-c-item list-c-item-pc" key={item.linkUrl}>
                        <div className="list-item-img">
                            <Image src={item.imgUrl} layout="fill" className="containImgs" alt={item.titleText}></Image>
                        </div>
                        <div className="list-item-text">{item.titleText}</div>
                        <Link
                            className="list-item-link ef-icon-arrowright"
                            href={
                                item?.link ||
                                (['/river-2-max-portable-power-station', '/river-2-pro-portable-power-station'].includes(item.linkUrl)
                                    ? '/river-2-portable-power-station'
                                    : item.linkUrl)
                            }
                            ariaLabel={msg3}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_product',
                                list_name: 'You might also like',
                                product_name: item.titleText,
                                button_name: 'Learn more',
                            }}
                        >
                            {msg3}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
